import Grid from '@material-ui/core/Grid'
import { LinkProps } from 'next/link'
import React, { PropsWithChildren } from 'react'

export type UtilityBarWrapperProps = Omit<React.ComponentProps<typeof Grid>, 'direction' | 'justifyContent' | 'alignItems'> & Pick<LinkProps, 'href'> & {
  title: string
}

export const UtilityBarWrapper: React.FC<PropsWithChildren<UtilityBarWrapperProps>> = ({ title, href, children, ...props }) => {
  return (
    <Grid {...props}
      item
      direction="column"
      justifyContent="flex-start"
      alignItems="flex-start">
      {children}
    </Grid>
  )
}
